/**
 *
 * This file is NOT generated yet, but it should be generated
 *
 * Add all kinds of types that we should actually generate instead of defining by ourselves
 * like graphql types or openapi spec types
 */

export type OrganizationMember = {
  user_id: string;
  role_name: string;
  picture: string;
  name: string;
  email: string;
  created: string;
};

export type PaginatedList<T extends Record<string, unknown>> = {
  start: number;
  limit: number;
  length: number;
  total: number;
  next: string;
} & T;

export type ProjectKey = {
  projectId: string;
  organizationId: string;
  encKey: string;
};

export type ProjectMember = {
  accountId: string;
  projectId: string;
  publicKey: string;
};

export type MemberProjectKey = {
  accountId: string;
  projectId: string;
  encSymmetricKey: string;
};

export type ResponseGetMyProjectKeys = {
  projectKeys: ProjectKey[];
  members: ProjectMember[];
};

export type ResponseGetAllMyProjectKeys = {
  projectKeys: ProjectKey[];
};

export type Whoami = {
  sessionAge: number;
  accountId: string;
  email: string;
  firstName: string;
  lastName: string;
  created: number;
  publicKey: string;
  encSymmetricKey: string;
  encPrivateKey: string;
  saltEnc: string;
  isPaymentRequired: boolean;
  isTrialing: boolean;
  isVerified: boolean;
  isAdmin: boolean;
  trialEnd: string;
  planName: string;
  planId: string;
  canManageTeams: boolean;
  maxTeamMembers: number;
  passwordSet: boolean;
  canUnsetPassword: boolean;
  unsubscribedFromEmails: boolean;
  customerId: string;
  subscriptionId: string;
  encDriverKey: string;
  encryptionEnabled: boolean;
};

export type GroupMemberInstruction = {
  accountId: string;
  email: string;
  publicKey: string;
};

export type GroupInviteKey = {
  projectId: string;
  organizationId: string;
  encKey: string;
};
export type GroupInstruction = {
  encryptionRequired: boolean;
  members: GroupMemberInstruction[];
  keys: GroupInviteKey[];
};

export type GroupMemberKey = {
  accountId: string;
  organizationId: string;
  projectId: string;
  encKey: string;
};

export type GroupMember = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  picture: string;
  roleName: string;
};

type TeamMember = {
  id: string;
  picture: string;
  email: string;
};

export type Team = {
  id: string;
  name: string;
  picture: string;
  description: string;
  isOnlyScim: boolean;
  members: TeamMember[];
  totalMembers: number;
};

export type TeamScimLink = {
  id: string;
  name: string;
  isReadOnly: boolean;
};

export type TeamOrgLink = {
  id: string;
  name: string;
};

export type TeamDetail = {
  id: string;
  name: string;
  picture: string;
  description: string;
  isOnlyScim: boolean;
  scimGroups: TeamScimLink[];
  orgLinks: TeamOrgLink[];
};

export interface EnterpriseMember {
  accountId: string;
  email: string;
  roleId: string;
  roleName: string;
  picture: string;
  loggedInAt?: string;
  e2eeEnabled?: boolean;
}

export enum EnterpriseRoleEnum {
  Owner = 'owner',
  CoOwner = 'co-owner',
  Billing = 'billing-only',
  Member = 'member',
  OwnAccount = 'your own account',
}
